import React, { Component, Fragment } from 'react';
import ScrollToTopOnMount from './ScrollToTopOnMount'
import PropTypes from 'prop-types';
import { API } from 'aws-amplify';
import { withRouter } from 'react-router';
import AuthService from './services/AuthService'
import { withStyles } from '@material-ui/core/styles';
import Grid from '@material-ui/core/Grid';
import Button from '@material-ui/core/Button';
import Paper from '@material-ui/core/Paper';
import Chip from '@material-ui/core/Chip';
import Typography from '@material-ui/core/Typography';
import { ValidatorForm, TextValidator} from 'react-material-ui-form-validator';
import Card from '@material-ui/core/Card';
import CardContent from '@material-ui/core/CardContent';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogTitle from '@material-ui/core/DialogTitle';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import moment from 'moment';
import { withSnackbar } from 'notistack';

const styles = theme => ({
  root: {
    ...theme.mixins.gutters(),
    paddingTop: theme.spacing.unit * 2,
    paddingBottom: theme.spacing.unit * 2,
  },
  container: {
    display: 'flex',
    flexWrap: 'wrap',
  },
  textField: {
    marginLeft: theme.spacing.unit,
    marginRight: theme.spacing.unit,
    width: 300,
  },
  formControl: {
    margin: theme.spacing.unit
  },
  chips: {
    display: 'flex',
    flexWrap: 'wrap',
  },
  chip: {
    margin: theme.spacing.unit / 4,
  },
  button: {
    margin: theme.spacing.unit,
  },
  PlasticBagCheckboxFormControl: {
    marginLeft: 30,
  },
});

const initialState = {
  searchCustomersResult: [],
  lastNameKanaSC: "",
  firstNameKanaSC: "",
  telSC: "",
  emailSC: "",
  reservationOpen: false,
  reservation: {
    baby_chairs: "0",
    baby_m: "",
    baby_w: "",
    customer_id: "",
    date: "",
    date_num: "1",
    discount: "",
    goto_discount: "no",
    elementary_school_high_m: "",
    elementary_school_high_w: "",
    elementary_school_low_m: "",
    elementary_school_low_w: "",
    elementary_school_middle_m: "",
    elementary_school_middle_w: "",
    extra_charge: "",
    fifties_m: "",
    fifties_w: "",
    forties_m: "",
    forties_w: "",
    high_school_m: "",
    high_school_w: "",
    information_status: "",
    input_rooms: [],
    is_jalan: "no",
    jalan_coupon: "",
    jalan_number: "",
    jalan_paid: "",
    jalan_point: "",
    jalan_subsidy: "",
    join_bed: "0",
    junior_high_school_m: "",
    junior_high_school_2: "",
    key: "info",
    kindergarten_m: "",
    kindergarten_w: "",
    orders: [],
    orders_id: "",
    over_seventies_m: "",
    over_seventies_w: "",
    plan_note: "",
    plans: [],
    plastic_bag: "",
    receipt_numbers: [],
    reservation_id: "",
    sixties_m: "",
    sixties_w: "",
    status: "",
    tax_rate: "",
    thirties_m: "",
    thirties_w: "",
    transportation: "",
    twenties_m: "",
    twenties_w: "",
    university_m: "",
    university_w: "",
  },
};



class SearchCustomers extends Component {

  constructor(props) {
    super(props);
    this.state = initialState;
    this.authApi = new AuthService();
  }

  componentWillMount(){
    this.authApi.isLogin()
    .then(
      (login) => {
        if(!login){
          this.props.history.push('/login');
        }
      }
    );
  }

  handleChange = (event, key) => {
    this.setState({
      [key] : event.target.value
    })
  }

  handleSearchCustomers = () => {
    let apiName = 'MyAPIGatewayAPI'; // replace this with your api name.
    let path = '/search-customers'; //replace this with the path you have configured on your API
    let myInit = {
        body: {
          lastNameKanaSC: this.state.lastNameKanaSC,
          firstNameKanaSC: this.state.firstNameKanaSC,
          telSC: this.state.telSC,
          emailSC: this.state.emailSC,
        }
    }

    const { enqueueSnackbar } = this.props;

    API.post(apiName, path, myInit).then(response => {
      console.log(response)
      this.setState({
        searchCustomersResult: response.customers
      });
      if(response.customers.length > 0){
        enqueueSnackbar(response.customers.length + '件が該当しました。', {variant : 'success'});
      }else{
        enqueueSnackbar('該当する顧客がいません。', {variant : 'warning'});
      }

    }).catch(error => {
      console.log(error)
      if(error.message){
        enqueueSnackbar(error.message, {variant : 'error'})
      }else{
        enqueueSnackbar('エラーが発生しました。', {variant : 'error'})
      }
    })
  }

  searchReservation = (reservationId) => {
    let apiName = 'MyAPIGatewayAPI'; // replace this with your api name.
    let path = '/reservation-for-refer'; //replace this with the path you have configured on your API

    let body = {
      reservationId : reservationId,
    };

    let myInit = {
        body: body, // replace this with attributes you need
    }

    const { enqueueSnackbar } = this.props;

    API.post(apiName, path, myInit).then(response => {
      console.log(response)
      this.setState({
        reservation: response.reservation,
        reservationOpen: true,
      })
    }).catch(error => {
      console.log(error)
      if(error.message){
        enqueueSnackbar(error.message, {variant : 'error'})
      }else{
        enqueueSnackbar('エラーが発生しました。', {variant : 'error'})
      }
    });

  }

  calculatePlanTotal = (plans, isJalan, jalanPaid, extraCharge, discount, gotoDiscount, jalanCoupon, jalanPoint, jalanSubsidy, taxRate) => {
    let gotoDiscountX = "no"
    if(gotoDiscount){
      gotoDiscountX = gotoDiscount
    }

    let total = 0;

    if(jalanPaid === "yes"){
      return total;
    }

    plans.map(n => {
      total += (Number(n.unitPrice) * Number(n.amount))
      return true;
    })

    if(isJalan === "no"){
      total += Number(extraCharge);
      total -= Number(discount);

      if(gotoDiscountX === "yes"){

        total = Math.floor(total * (1 + Number(taxRate))) - Math.ceil(total * (1 + Number(taxRate)) * 0.35)
      }
    }

    if(isJalan === "yes"){
      total -= Number(jalanCoupon);
      total -= Number(jalanPoint);
      total -= Number(jalanSubsidy);
    }


    return total;
  }

  calculateTaxTotal = (plans, isJalan, jalanPaid, extraCharge, discount, gotoDiscount, jalanCoupon, jalanPoint, jalanSubsidy, orders, taxRate) => {
    let gotoDiscountX = "no"
    if(gotoDiscount){
      gotoDiscountX = gotoDiscount
    }

    let tax = 0;

    if(isJalan === "no" && gotoDiscountX === "no"){
      tax += Math.floor(this.calculatePlanTotal(plans, isJalan, jalanPaid, extraCharge, discount, gotoDiscountX, jalanCoupon, jalanPoint, jalanSubsidy, taxRate) * Number(taxRate))
    }

    if(isJalan === "yes"  || gotoDiscountX === "yes"){
      tax += Math.floor(this.calculatePlanTotal(plans, isJalan, jalanPaid, extraCharge, discount, gotoDiscountX, jalanCoupon, jalanPoint, jalanSubsidy, taxRate) * (Number(taxRate)) / (1 + Number(taxRate)))
    }

    tax += Math.floor(this.calculateOrderOuterTaxTotal(orders) * Number(taxRate))

    tax += Math.floor(this.calculateOrderInnerTaxTotal(orders) * (Number(taxRate)) / (1 + Number(taxRate)))

    return tax;

  }

  calculateTotal = (plans, isJalan, jalanPaid, extraCharge, discount, gotoDiscount, jalanCoupon, jalanPoint, jalanSubsidy, orders, taxRate) => {
    let gotoDiscountX = "no"
    if(gotoDiscount){
      gotoDiscountX = gotoDiscount
    }

    let total = 0;

    if(isJalan === "no" && gotoDiscountX === "no"){
      total += Math.floor(this.calculatePlanTotal(plans, isJalan, jalanPaid, extraCharge, discount, gotoDiscountX, jalanCoupon, jalanPoint, jalanSubsidy, taxRate) * (1 + Number(taxRate)))
    }

    if(isJalan === "yes" || gotoDiscountX === "yes"){
      total += this.calculatePlanTotal(plans, isJalan, jalanPaid, extraCharge, discount, gotoDiscountX, jalanCoupon, jalanPoint, jalanSubsidy, taxRate)
    }

    total += Math.floor(this.calculateOrderOuterTaxTotal(orders) * (1 + Number(taxRate)))

    total += this.calculateOrderInnerTaxTotal(orders)

    return total;

  }

  calculateOrderOuterTaxTotal = (orders) => {
    let total = 0;

    orders.map(n => {
      if(n.taxType === "税別"){
        total += Number(n.price) * Number(n.amount)
      }
      return true;
    })

    return total;
  }

  calculateOrderInnerTaxTotal = (orders,taxRate) => {
    let total = 0;

    orders.map(n => {
      if(n.taxType === "税込"){
        total += Number(n.price) * Number(n.amount)
      }
      return true;
    })

    return total;
  }

  handleCloseDialog = name => {
    this.setState({ [name]: false });
  }

  nl2brJsx = (str) =>{
    let lines = [];
    let array = str.split("\n");
    for(let i in array){
      lines.push(<Fragment key={"lines" + i}>{array[i]}<br/></Fragment>);
    }
    return lines;
  }

  render() {
    const {classes} = this.props
    const {
      searchCustomersResult,
      lastNameKanaSC,
      firstNameKanaSC,
      telSC,
      emailSC,
      reservationOpen,
      reservation
    } = this.state;

    let rooms = "";
    for(let i in reservation.input_rooms){
      rooms = rooms + reservation.input_rooms[i]
      if(i !== reservation.input_rooms.length - 1){
        rooms = rooms + " "
      }
    }

    console.log(rooms)

    return (
      <Fragment>
        <ScrollToTopOnMount/>
        <Grid container spacing={24} className={classes.container}>
          <Grid item xs={12}>
            <Typography variant="h4" gutterBottom>
              顧客検索
            </Typography>
          </Grid>
          <Grid item>
            <Paper className={classes.root} elevation={1}>
            <ValidatorForm
              ref="form"
              onSubmit={() => this.handleSearchCustomers()}
              onError={
                errors => {
                  console.log(errors);
                  const { enqueueSnackbar } = this.props;
                  enqueueSnackbar('検索内容に無効な値が含まれています。', {variant : 'warning'});
                }
              }
            >
              <TextValidator
                className={classes.textField}
                name="lastNameKanaSC"
                label="氏(カナ)"
                value={lastNameKanaSC}
                margin="normal"
                onChange={(e) => this.handleChange(e, 'lastNameKanaSC')}
                pattern="^[ァ-ンヴー]+$ , [\\u30A1-\\u30FF]*"
                validators={['matchRegexp:^[ァ-ンヴー]+$']}
                errorMessages={['カタカナで入力してください']}
                helperText="カタカナ入力"
              />
              <TextValidator
                className={classes.textField}
                name="firstNameKanaSC"
                label="名（カナ）"
                value={firstNameKanaSC}
                margin="normal"
                onChange={(e) => this.handleChange(e, 'firstNameKanaSC')}
                pattern="^[ァ-ンヴー]+$ , [\\u30A1-\\u30FF]*"
                validators={['matchRegexp:^[ァ-ンヴー]+$']}
                errorMessages={['カタカナで入力してください']}
                helperText="カタカナ入力"
              />
              <br/>
              <TextValidator
                className={classes.textField}
                name="telSC"
                label="電話番号"
                value={telSC}
                margin="normal"
                onChange={(e) => this.handleChange(e, 'telSC')}
                type="tel"
                validators={['matchRegexp:^(0{1}\\d{1,10})$']}
                errorMessages={['電話番号形式で入力してください']}
                helperText="ハイフンなし"
              />
              <br/>
              <TextValidator
                className={classes.textField}
                name="emailSC"
                label="email"
                value={emailSC}
                margin="normal"
                onChange={(e) => this.handleChange(e, 'emailSC')}
              />
              <br/>
              <Typography style={{marginLeft: 10, marginTop:20, color:"#8c8c8c"}}>
                ※入力されている項目のみで前方一致の絞り込み検索
              </Typography>
              <br/>
              <Button type="submit" variant="contained" color="primary" className={classes.button} style={{marginTop:40}}>
                検索
              </Button>
            </ValidatorForm>
            <br/>
            <Chip
              label={"該当件数:　　　" + searchCustomersResult.length}
              className={classes.chip}
              style={{marginTop:20, marginLeft:"63%", width:150, backgroundColor:"#efefef"}}
            />
            {searchCustomersResult.map(n =>
              {
                return (
                  <Card style={{width:"90%", marginTop:20, background: "#ececec"}} key={n.customer_id}>
                    <CardContent>
                      <Typography className={classes.title} color="textSecondary" gutterBottom>
                        {n.last_name_kana} {n.first_name_kana}
                      </Typography>
                      <Typography variant="h5" component="h2">
                        {n.last_name} {n.first_name} <div style={{marginLeft: 10, fontSize:"0.8em", display: "inline"}}>様</div>
                      </Typography>
                      <Typography variant="caption" style={{marginTop:10, marginBottom:8}}>
                        住所
                      </Typography>
                      <Typography variant="body1" style={{marginLeft:5}}>
                        〒{n.post_num.slice(0, 3)}-{n.post_num.slice(4, 7)}<br/>
                        {n.address_prefectures} {n.address_city} {n.address_other} {n.address_building}
                      </Typography>
                      <Typography variant="caption" style={{marginTop:10, marginBottom:8}}>
                        電話番号
                      </Typography>
                      <Typography variant="body1" style={{marginLeft:5}}>
                        {n.tel}
                      </Typography>
                      {n.tel2 &&
                        <Fragment>
                          <Typography variant="caption" style={{marginTop:10, marginBottom:8}}>
                            電話番号2
                          </Typography>
                          <Typography variant="body1" style={{marginLeft:5}}>
                            {n.tel2}
                          </Typography>
                        </Fragment>
                      }
                      {n.email &&
                        <Fragment>
                          <Typography variant="caption" style={{marginTop:10, marginBottom:8}}>
                            email
                          </Typography>
                          <Typography variant="body1" style={{marginLeft:5}}>
                            {n.email}
                          </Typography>
                        </Fragment>
                      }
                      {n.customer_note &&
                        <Fragment>
                          <Typography variant="caption" style={{marginTop:10, marginBottom:8}}>
                            備考
                          </Typography>
                          <Typography variant="body1" style={{marginLeft:5}}>
                            {this.nl2brJsx(n.customer_note)}
                          </Typography>
                        </Fragment>
                      }
                      <Typography variant="caption" style={{marginTop:40, marginBottom:8}}>
                        前回宿泊開始日
                      </Typography>
                      {
                        n.reservation_date_history.map((m, i) => (
                          <Button
                            type="submit"
                            key={n.customer_id +  m}
                            variant="contained"
                            color="default"
                            className={classes.button}
                            style={{margin:"1%", backgroundColor: "#ffffff"}}
                            onClick={() => this.searchReservation(n.reservation_id_history[i])}
                          >
                            {moment(m).format("YYYY年MM月DD日(ddd)")}
                          </Button>
                        ))
                      }
                    </CardContent>
                  </Card>
                );
              }
            )}
            </Paper>
          </Grid>
        </Grid>
        <Dialog
          open={reservationOpen}
          onClose={() => this.handleCloseDialog('reservationOpen')}
          aria-labelledby="alert-dialog-slide-title"
          aria-describedby="alert-dialog-slide-description"
          fullWidth={true}
          maxWidth="md"
        >
          <DialogTitle id="scroll-dialog-title">宿泊情報詳細</DialogTitle>
          <DialogContent>
            <Grid container spacing={24} className={classes.container}>
              <Grid item xs={12}>
                <Typography variant="caption" style={{marginLeft:7,marginTop:20}}>
                  状態
                </Typography>

                {(() => {
                  if(reservation.status.startsWith("active")){
                    return (
                      <Typography variant="body1" style={{marginLeft:12, color: "blue"}}>
                        チェックアウト前
                      </Typography>
                    )
                  }

                  if(reservation.status.includes("checked_out")){
                    return (
                      <Typography variant="body1" style={{marginLeft:12}}>
                        チェックアウト済み
                      </Typography>
                    )
                  }

                  if(reservation.status.includes("canceled")){
                    return (
                      <Typography variant="body1" style={{marginLeft:12, color: "red"}}>
                        キャンセル済み
                      </Typography>
                    )
                  }
                })()}

              </Grid>
              <Grid item xs={1}>
                <Typography variant="caption" style={{marginLeft:7,marginTop:20}}>
                  お部屋
                </Typography>
                <Typography variant="body1" style={{marginLeft:12}}>
                  {rooms}
                </Typography>
              </Grid>
              <Grid item xs={3}>
                <Typography variant="caption" style={{marginLeft:7,marginTop:20}}>
                  宿泊開始日
                </Typography>
                <Typography variant="body1" style={{marginLeft:12}}>
                  {moment(reservation.date).format("YYYY年MM月DD日(ddd)")}
                </Typography>
              </Grid>
              <Grid item xs={2}>
                <Typography variant="caption" style={{marginLeft:7,marginTop:20}}>
                  泊数
                </Typography>
                <Typography variant="body1" style={{marginLeft:12}}>
                  {reservation.date_num}泊
                </Typography>
              </Grid>

              {(() => {
                 if (reservation.jalan_number){
                   return (
                     <Grid item xs={3}>
                       <Typography variant="caption" style={{marginLeft:7,marginTop:20}}>
                         じゃらんNo.
                       </Typography>
                       <Typography variant="body1" style={{marginLeft:12}}>
                         {reservation.jalan_number}
                       </Typography>
                     </Grid>
                   )
                 }else{
                   return (
                     <Grid item xs={3}>
                     </Grid>
                   )
                 }
               })()}

             {reservation.plan_note &&
               <Grid item xs={6}>
                 <Typography variant="caption" style={{marginLeft:7,marginTop:20}}>
                   備考
                 </Typography>
                 <Typography variant="body1" style={{marginLeft:12}}>
                   {this.nl2brJsx(reservation.plan_note)}
                 </Typography>
               </Grid>
             }

             {(() => {
               if (reservation.receipt_numbers.length > 0){
                 return(
                   <Grid item xs={12} style={{marginTop: 0, paddingBottom: 5}}>
                     <Typography variant="caption" style={{marginLeft:7,marginTop:20}}>
                       発行済みレシートNo.
                     </Typography>
                   </Grid>
                 )
               }
             })()}


             {reservation.receipt_numbers.map((n, i) => {
               return (
                 <Grid item key={n} xs={12} style={{marginTop: 0, paddingTop: 0}}>
                   <Typography key={n} variant="body1" style={{marginLeft:12}}>
                     {n}<br/>
                   </Typography>
                 </Grid>
               )
             })}

              <Grid item xs={11}>
                <Table className={classes.table} style={{marginTop: 20, marginBottom:20}}>
                  <TableHead style={{backgroundColor:"#f3f3f3"}}>
                    <TableRow>
                      <TableCell className={classes.longTableCell} align="left" padding="dense">品名</TableCell>
                      <TableCell style={{color: "#676767"}} align="center" padding="dense">単価</TableCell>
                      <TableCell style={{color: "#676767"}} align="center" padding="dense">数量</TableCell>
                      <TableCell style={{color: "#676767"}} align="center" padding="dense">消費税区分</TableCell>
                      <TableCell style={{color: "#676767"}} align="center" padding="dense">小計</TableCell>
                    </TableRow>
                  </TableHead>
                  <TableBody key={reservation.reservation_id}>
                    {reservation.plans.map((m,i) => {
                      if(reservation.is_jalan === "no"){
                        return(
                          <TableRow key={"notJalan" + i}>
                            <TableCell className={classes.longTableCell} align="left" padding="dense">{m.basePlan}ご宿泊料({m.mealPlan}・ベッド{m.bedPlan})</TableCell>
                            <TableCell style={{color: "#676767"}} align="right" padding="dense">¥ {Number(m.unitPrice).toLocaleString()}</TableCell>
                            <TableCell style={{color: "#676767"}} align="right" padding="dense">{m.amount}</TableCell>
                            <TableCell style={{color: "#676767"}} align="center" padding="dense">税別</TableCell>
                            <TableCell style={{color: "#676767"}} align="right" padding="dense">¥ {(Number(m.unitPrice) * Number(m.amount)).toLocaleString()}</TableCell>
                          </TableRow>
                        )
                      }

                      if(reservation.is_jalan === "yes"){
                        return(
                          <TableRow key={"jalan" + i}>
                            <TableCell className={classes.longTableCell} align="left" padding="dense">じゃらん {m.basePlan}ご宿泊料({m.mealPlan}・ベッド{m.bedPlan})</TableCell>
                            <TableCell style={{color: "#676767"}} align="right" padding="dense">¥ {Number(m.unitPrice).toLocaleString()}</TableCell>
                            <TableCell style={{color: "#676767"}} align="right" padding="dense">{m.amount}</TableCell>
                            <TableCell style={{color: "#676767"}} align="center" padding="dense">税込</TableCell>
                            <TableCell style={{color: "#676767"}} align="right" padding="dense">¥ {(Number(m.unitPrice) * Number(m.amount)).toLocaleString()}</TableCell>
                          </TableRow>
                        )
                      }

                      return true;

                    })}

                    {(() => {

                      if (reservation.is_jalan === "no" && reservation.extra_charge && reservation.discount){
                        return (
                          <Fragment>
                            <TableRow>
                              <TableCell className={classes.longTableCell} align="left" padding="dense">その他サービス料</TableCell>
                              <TableCell style={{color: "#676767"}} align="right" padding="dense"></TableCell>
                              <TableCell style={{color: "#676767"}} align="right" padding="dense"></TableCell>
                              <TableCell style={{color: "#676767"}} align="center" padding="dense"></TableCell>
                              <TableCell style={{color: "#676767"}} align="right" padding="dense">¥ {Number(reservation.extra_charge).toLocaleString()}</TableCell>
                            </TableRow>
                            <TableRow>
                              <TableCell className={classes.longTableCell} align="left" padding="dense">割引額</TableCell>
                              <TableCell style={{color: "#676767"}} align="right" padding="dense"></TableCell>
                              <TableCell style={{color: "#676767"}} align="right" padding="dense"></TableCell>
                              <TableCell style={{color: "#676767"}} align="center" padding="dense"></TableCell>
                              <TableCell style={{color: "#676767"}} align="right" padding="dense">¥ -{Number(reservation.discount).toLocaleString()}</TableCell>
                            </TableRow>
                          </Fragment>
                        )
                      }

                      if (reservation.is_jalan === "no" && reservation.extra_charge){
                        return (
                          <TableRow>
                            <TableCell className={classes.longTableCell} align="left" padding="dense">その他サービス料</TableCell>
                            <TableCell style={{color: "#676767"}} align="right" padding="dense"></TableCell>
                            <TableCell style={{color: "#676767"}} align="right" padding="dense"></TableCell>
                            <TableCell style={{color: "#676767"}} align="center" padding="dense"></TableCell>
                            <TableCell style={{color: "#676767"}} align="right" padding="dense">¥ {Number(reservation.extra_charge).toLocaleString()}</TableCell>
                          </TableRow>
                        )
                      }

                      if (reservation.is_jalan === "no" && reservation.discount){
                        return (
                          <TableRow>
                            <TableCell className={classes.longTableCell} align="left" padding="dense">割引額</TableCell>
                            <TableCell style={{color: "#676767"}} align="right" padding="dense"></TableCell>
                            <TableCell style={{color: "#676767"}} align="right" padding="dense"></TableCell>
                            <TableCell style={{color: "#676767"}} align="center" padding="dense"></TableCell>
                            <TableCell style={{color: "#676767"}} align="right" padding="dense">¥ -{Number(reservation.discount).toLocaleString()}</TableCell>
                          </TableRow>
                        )
                      }


                      if (reservation.is_jalan === "yes" && reservation.jalan_coupon && reservation.jalan_point && reservation.jalan_subsidy){
                        return (
                          <Fragment>
                            <TableRow>
                              <TableCell className={classes.longTableCell} align="left" padding="dense">じゃらんクーポン利用額</TableCell>
                              <TableCell style={{color: "#676767"}} align="right" padding="dense"></TableCell>
                              <TableCell style={{color: "#676767"}} align="right" padding="dense"></TableCell>
                              <TableCell style={{color: "#676767"}} align="center" padding="dense"></TableCell>
                              <TableCell style={{color: "#676767"}} align="right" padding="dense">¥ -{reservation.jalan_coupon}</TableCell>
                            </TableRow>
                            <TableRow>
                              <TableCell className={classes.longTableCell} align="left" padding="dense">じゃらんポイント利用額</TableCell>
                              <TableCell style={{color: "#676767"}} align="right" padding="dense"></TableCell>
                              <TableCell style={{color: "#676767"}} align="right" padding="dense"></TableCell>
                              <TableCell style={{color: "#676767"}} align="center" padding="dense"></TableCell>
                              <TableCell style={{color: "#676767"}} align="right" padding="dense">¥ -{reservation.jalan_point}</TableCell>
                            </TableRow>
                            <TableRow>
                              <TableCell className={classes.longTableCell} align="left" padding="dense">補助金利用額</TableCell>
                              <TableCell style={{color: "#676767"}} align="right" padding="dense"></TableCell>
                              <TableCell style={{color: "#676767"}} align="right" padding="dense"></TableCell>
                              <TableCell style={{color: "#676767"}} align="center" padding="dense"></TableCell>
                              <TableCell style={{color: "#676767"}} align="right" padding="dense">¥ -{reservation.jalan_subsidy}</TableCell>
                            </TableRow>
                          </Fragment>
                        )
                      }

                      if (reservation.is_jalan === "yes" && reservation.jalan_coupon && reservation.jalan_point){
                        return (
                          <Fragment>
                            <TableRow>
                              <TableCell className={classes.longTableCell} align="left" padding="dense">じゃらんクーポン利用額</TableCell>
                              <TableCell style={{color: "#676767"}} align="right" padding="dense"></TableCell>
                              <TableCell style={{color: "#676767"}} align="right" padding="dense"></TableCell>
                              <TableCell style={{color: "#676767"}} align="center" padding="dense"></TableCell>
                              <TableCell style={{color: "#676767"}} align="right" padding="dense">¥ -{reservation.jalan_coupon}</TableCell>
                            </TableRow>
                            <TableRow>
                              <TableCell className={classes.longTableCell} align="left" padding="dense">じゃらんポイント利用額</TableCell>
                              <TableCell style={{color: "#676767"}} align="right" padding="dense"></TableCell>
                              <TableCell style={{color: "#676767"}} align="right" padding="dense"></TableCell>
                              <TableCell style={{color: "#676767"}} align="center" padding="dense"></TableCell>
                              <TableCell style={{color: "#676767"}} align="right" padding="dense">¥ -{reservation.jalan_point}</TableCell>
                            </TableRow>
                          </Fragment>
                        )
                      }

                      if (reservation.is_jalan === "yes" && reservation.jalan_coupon && reservation.jalan_subsidy){
                        return (
                          <Fragment>
                            <TableRow>
                              <TableCell className={classes.longTableCell} align="left" padding="dense">じゃらんクーポン利用額</TableCell>
                              <TableCell style={{color: "#676767"}} align="right" padding="dense"></TableCell>
                              <TableCell style={{color: "#676767"}} align="right" padding="dense"></TableCell>
                              <TableCell style={{color: "#676767"}} align="center" padding="dense"></TableCell>
                              <TableCell style={{color: "#676767"}} align="right" padding="dense">¥ -{reservation.jalan_coupon}</TableCell>
                            </TableRow>
                            <TableRow>
                              <TableCell className={classes.longTableCell} align="left" padding="dense">補助金利用額</TableCell>
                              <TableCell style={{color: "#676767"}} align="right" padding="dense"></TableCell>
                              <TableCell style={{color: "#676767"}} align="right" padding="dense"></TableCell>
                              <TableCell style={{color: "#676767"}} align="center" padding="dense"></TableCell>
                              <TableCell style={{color: "#676767"}} align="right" padding="dense">¥ -{reservation.jalan_subsidy}</TableCell>
                            </TableRow>
                          </Fragment>
                        )
                      }

                      if (reservation.is_jalan === "yes" && reservation.jalan_point && reservation.jalan_subsidy){
                        return (
                          <Fragment>
                            <TableRow>
                              <TableCell className={classes.longTableCell} align="left" padding="dense">じゃらんポイント利用額</TableCell>
                              <TableCell style={{color: "#676767"}} align="right" padding="dense"></TableCell>
                              <TableCell style={{color: "#676767"}} align="right" padding="dense"></TableCell>
                              <TableCell style={{color: "#676767"}} align="center" padding="dense"></TableCell>
                              <TableCell style={{color: "#676767"}} align="right" padding="dense">¥ -{reservation.jalan_point}</TableCell>
                            </TableRow>
                            <TableRow>
                              <TableCell className={classes.longTableCell} align="left" padding="dense">補助金利用額</TableCell>
                              <TableCell style={{color: "#676767"}} align="right" padding="dense"></TableCell>
                              <TableCell style={{color: "#676767"}} align="right" padding="dense"></TableCell>
                              <TableCell style={{color: "#676767"}} align="center" padding="dense"></TableCell>
                              <TableCell style={{color: "#676767"}} align="right" padding="dense">¥ -{reservation.jalan_subsidy}</TableCell>
                            </TableRow>
                          </Fragment>
                        )
                      }

                      if (reservation.is_jalan === "yes" && reservation.jalan_coupon){
                        return (
                          <TableRow>
                            <TableCell className={classes.longTableCell} align="left" padding="dense">じゃらんクーポン利用額</TableCell>
                            <TableCell style={{color: "#676767"}} align="right" padding="dense"></TableCell>
                            <TableCell style={{color: "#676767"}} align="right" padding="dense"></TableCell>
                            <TableCell style={{color: "#676767"}} align="center" padding="dense"></TableCell>
                            <TableCell style={{color: "#676767"}} align="right" padding="dense">¥ -{reservation.jalan_coupon}</TableCell>
                          </TableRow>
                        )
                      }

                      if (reservation.is_jalan === "yes" && reservation.jalan_point){
                        return (
                          <TableRow>
                            <TableCell className={classes.longTableCell} align="left" padding="dense">じゃらんポイント利用額</TableCell>
                            <TableCell style={{color: "#676767"}} align="right" padding="dense"></TableCell>
                            <TableCell style={{color: "#676767"}} align="right" padding="dense"></TableCell>
                            <TableCell style={{color: "#676767"}} align="center" padding="dense"></TableCell>
                            <TableCell style={{color: "#676767"}} align="right" padding="dense">¥ -{reservation.jalan_point}</TableCell>
                          </TableRow>
                      )
                      }
                      if (reservation.is_jalan === "yes" && reservation.jalan_subsidy){
                        return (
                          <TableRow>
                            <TableCell className={classes.longTableCell} align="left" padding="dense">補助金利用額</TableCell>
                            <TableCell style={{color: "#676767"}} align="right" padding="dense"></TableCell>
                            <TableCell style={{color: "#676767"}} align="right" padding="dense"></TableCell>
                            <TableCell style={{color: "#676767"}} align="center" padding="dense"></TableCell>
                            <TableCell style={{color: "#676767"}} align="right" padding="dense">¥ -{reservation.jalan_subsidy}</TableCell>
                          </TableRow>
                        )
                      }

                     })()}


                     {(() => {
                        if (reservation.is_jalan === "yes" && reservation.jalan_paid === "yes"){
                          return (
                            <TableRow style={{backgroundColor:"#f3f3f3"}}>
                              <TableCell className={classes.longTableCell} align="left" padding="dense">じゃらんお支払い済み金額</TableCell>
                              <TableCell style={{color: "#676767"}} align="right" padding="dense"></TableCell>
                              <TableCell style={{color: "#676767"}} align="right" padding="dense"></TableCell>
                              <TableCell style={{color: "#676767"}} align="center" padding="dense"></TableCell>
                              <TableCell style={{color: "#676767"}} align="right" padding="dense">¥ -{this.calculatePlanTotal(reservation.plans, reservation.is_jalan, "no", reservation.extra_charge, reservation.discount, reservation.goto_discount, reservation.jalan_coupon, reservation.jalan_point, reservation.jalan_subsidy,reservation.tax_rate).toLocaleString()}</TableCell>
                            </TableRow>
                          )
                        }
                      })()}

                      {(() => {
                         if (reservation.goto_discount === "yes"){
                           return (
                             <TableRow>
                               <TableCell className={classes.longTableCell} align="left" padding="dense">GoToキャンペーン割引額</TableCell>
                               <TableCell style={{color: "#676767"}} align="right" padding="dense"></TableCell>
                               <TableCell style={{color: "#676767"}} align="right" padding="dense"></TableCell>
                               <TableCell style={{color: "#676767"}} align="center" padding="dense"></TableCell>
                               <TableCell style={{color: "#676767"}} align="right" padding="dense">¥ -{Math.ceil(this.calculatePlanTotal(reservation.plans, reservation.is_jalan, "no", reservation.extra_charge, reservation.discount, reservation.goto_discount, reservation.jalan_coupon, reservation.jalan_point, reservation.jalan_subsidy,reservation.tax_rate) * 1.1 * 0.35).toLocaleString()}</TableCell>
                             </TableRow>
                           )
                         }
                       })()}


                    <TableRow style={{backgroundColor:"#f3f3f3"}}>
                      <TableCell className={classes.longTableCell} align="left" padding="dense">ご宿泊料小計</TableCell>
                      <TableCell style={{color: "#676767"}} align="right" padding="dense"></TableCell>
                      <TableCell style={{color: "#676767"}} align="right" padding="dense"></TableCell>
                      <TableCell style={{color: "#676767"}} align="center" padding="dense"></TableCell>
                      <TableCell style={{color: "#676767"}} align="right" padding="dense">¥ {this.calculatePlanTotal(reservation.plans, reservation.is_jalan, "no", reservation.extra_charge, reservation.discount, reservation.goto_discount, reservation.jalan_coupon, reservation.jalan_point, reservation.jalan_subsidy,reservation.tax_rate).toLocaleString()}</TableCell>
                    </TableRow>

                    {(() => {
                       if (reservation.is_jalan === "yes" && reservation.jalan_paid === "no"){
                         return (
                           <TableRow style={{backgroundColor:"#f3f3f3"}}>
                             <TableCell className={classes.longTableCell} align="left" padding="dense">( 内消費税</TableCell>
                             <TableCell style={{color: "#676767"}} align="right" padding="dense"></TableCell>
                             <TableCell style={{color: "#676767"}} align="right" padding="dense"></TableCell>
                             <TableCell style={{color: "#676767"}} align="center" padding="dense"></TableCell>
                             <TableCell style={{color: "#676767"}} align="right" padding="dense">¥ {
                               Math.floor(this.calculatePlanTotal(reservation.plans, reservation.is_jalan, "no", reservation.extra_charge, reservation.discount, reservation.goto_discount, reservation.jalan_coupon, reservation.jalan_point, reservation.jalan_subsidy,reservation.tax_rate) * (Number(reservation.tax_rate)) / (1 + Number(reservation.tax_rate))).toLocaleString()
                             } )</TableCell>
                           </TableRow>
                         )
                       }
                     })()}

                    <TableRow>
                      <TableCell className={classes.longTableCell} align="left" padding="dense"></TableCell>
                      <TableCell style={{color: "#676767"}} align="right" padding="dense"></TableCell>
                      <TableCell style={{color: "#676767"}} align="right" padding="dense"></TableCell>
                      <TableCell style={{color: "#676767"}} align="center" padding="dense"></TableCell>
                      <TableCell style={{color: "#676767"}} align="right" padding="dense"></TableCell>
                    </TableRow>

                    {(() => {
                       if (this.calculateOrderOuterTaxTotal(reservation.orders) > 0){
                         return (
                           <Fragment>
                             {reservation.orders.map((m,i) => {
                               if(m.taxType === "税別"){
                                 return(
                                   <TableRow key={m.name + "outerTax" +  i}>
                                     <TableCell className={classes.longTableCell} align="left" padding="dense">{m.name}</TableCell>
                                     <TableCell style={{color: "#676767"}} align="right" padding="dense">¥ {Number(m.price).toLocaleString()}</TableCell>
                                     <TableCell style={{color: "#676767"}} align="right" padding="dense">{m.amount}</TableCell>
                                     <TableCell style={{color: "#676767"}} align="center" padding="dense">{m.taxType}</TableCell>
                                     <TableCell style={{color: "#676767"}} align="right" padding="dense">¥ {(Number(m.price) * Number(m.amount)).toLocaleString()}</TableCell>
                                   </TableRow>
                                 )
                               }
                               return true;
                              })}
                              <TableRow style={{backgroundColor:"#f3f3f3"}}>
                                <TableCell className={classes.longTableCell} align="left" padding="dense">税別ご飲食費小計</TableCell>
                                <TableCell style={{color: "#676767"}} align="right" padding="dense"></TableCell>
                                <TableCell style={{color: "#676767"}} align="right" padding="dense"></TableCell>
                                <TableCell style={{color: "#676767"}} align="center" padding="dense"></TableCell>
                                <TableCell style={{color: "#676767"}} align="right" padding="dense">¥ {this.calculateOrderOuterTaxTotal(reservation.orders).toLocaleString()}</TableCell>
                              </TableRow>
                              <TableRow>
                                <TableCell className={classes.longTableCell} align="left" padding="dense"></TableCell>
                                <TableCell style={{color: "#676767"}} align="right" padding="dense"></TableCell>
                                <TableCell style={{color: "#676767"}} align="right" padding="dense"></TableCell>
                                <TableCell style={{color: "#676767"}} align="center" padding="dense"></TableCell>
                                <TableCell style={{color: "#676767"}} align="right" padding="dense"></TableCell>
                              </TableRow>
                            </Fragment>
                         )
                       }
                     })()}

                     {(() => {
                        if (this.calculateOrderInnerTaxTotal(reservation.orders) > 0){
                          return (
                            <Fragment>
                              {reservation.orders.map((m,i) => {
                                if(m.taxType === "税込"){
                                  return(
                                    <TableRow key={m.name + "innerTax" +  i}>
                                      <TableCell className={classes.longTableCell} align="left" padding="dense">{m.name}</TableCell>
                                      <TableCell style={{color: "#676767"}} align="right" padding="dense">¥ {Number(m.price).toLocaleString()}</TableCell>
                                      <TableCell style={{color: "#676767"}} align="right" padding="dense">{m.amount}</TableCell>
                                      <TableCell style={{color: "#676767"}} align="center" padding="dense">{m.taxType}</TableCell>
                                      <TableCell style={{color: "#676767"}} align="right" padding="dense">¥ {(Number(m.price) * Number(m.amount)).toLocaleString()}</TableCell>
                                    </TableRow>
                                  )
                                }
                                return true;
                              })}
                              <TableRow style={{backgroundColor:"#f3f3f3"}}>
                                <TableCell className={classes.longTableCell} align="left" padding="dense">税込ご飲食費小計</TableCell>
                                <TableCell style={{color: "#676767"}} align="right" padding="dense"></TableCell>
                                <TableCell style={{color: "#676767"}} align="right" padding="dense"></TableCell>
                                <TableCell style={{color: "#676767"}} align="center" padding="dense"></TableCell>
                                <TableCell style={{color: "#676767"}} align="right" padding="dense">¥ {this.calculateOrderInnerTaxTotal(reservation.orders).toLocaleString()}</TableCell>
                              </TableRow>
                              <TableRow style={{backgroundColor:"#f3f3f3"}}>
                                <TableCell className={classes.longTableCell} align="left" padding="dense">( 内消費税</TableCell>
                                <TableCell style={{color: "#676767"}} align="right" padding="dense"></TableCell>
                                <TableCell style={{color: "#676767"}} align="right" padding="dense"></TableCell>
                                <TableCell style={{color: "#676767"}} align="center" padding="dense"></TableCell>
                                <TableCell style={{color: "#676767"}} align="right" padding="dense">¥ {
                                  Math.floor(this.calculateOrderInnerTaxTotal(reservation.orders) * (Number(reservation.tax_rate)) / (1 + Number(reservation.tax_rate))).toLocaleString()
                                } )</TableCell>
                              </TableRow>
                              <TableRow>
                                <TableCell className={classes.longTableCell} align="left" padding="dense"></TableCell>
                                <TableCell style={{color: "#676767"}} align="right" padding="dense"></TableCell>
                                <TableCell style={{color: "#676767"}} align="right" padding="dense"></TableCell>
                                <TableCell style={{color: "#676767"}} align="center" padding="dense"></TableCell>
                                <TableCell style={{color: "#676767"}} align="right" padding="dense"></TableCell>
                              </TableRow>
                             </Fragment>
                          )
                        }
                      })()}

                    <TableRow style={{backgroundColor:"#f3f3f3"}}>
                      <TableCell className={classes.longTableCell} align="left" padding="dense">消費税 ({Number(reservation.tax_rate) * 100}%)</TableCell>
                      <TableCell style={{color: "#676767"}} align="right" padding="dense"></TableCell>
                      <TableCell style={{color: "#676767"}} align="right" padding="dense"></TableCell>
                      <TableCell style={{color: "#676767"}} align="center" padding="dense"></TableCell>
                      <TableCell style={{color: "#676767"}} align="right" padding="dense">¥ {this.calculateTaxTotal(reservation.plans, reservation.is_jalan, reservation.jalan_paid, reservation.extra_charge, reservation.discount, reservation.goto_discount, reservation.jalan_coupon, reservation.jalan_point, reservation.jalan_subsidy, reservation.orders, reservation.tax_rate).toLocaleString()}</TableCell>
                    </TableRow>
                    <TableRow style={{backgroundColor:"#d0d0d0"}}>
                      <TableCell className={classes.longTableCell} align="left" padding="dense">合計</TableCell>
                      <TableCell style={{color: "#676767"}} align="right" padding="dense"></TableCell>
                      <TableCell style={{color: "#676767"}} align="right" padding="dense"></TableCell>
                      <TableCell style={{color: "#676767"}} align="center" padding="dense"></TableCell>
                      <TableCell style={{color: "#676767"}} align="right" padding="dense">￥ {this.calculateTotal(reservation.plans, reservation.is_jalan, reservation.jalan_paid, reservation.extra_charge, reservation.discount, reservation.goto_discount, reservation.jalan_coupon, reservation.jalan_point, reservation.jalan_subsidy, reservation.orders, reservation.tax_rate).toLocaleString()}</TableCell>
                    </TableRow>
                  </TableBody>
                </Table>
              </Grid>
            </Grid>
          </DialogContent>
          <DialogActions>
            <Button onClick={() => this.handleCloseDialog('reservationOpen')} color="primary">
              閉じる
            </Button>
          </DialogActions>
        </Dialog>
      </Fragment>
    );
  }
}

SearchCustomers.propTypes = {
  classes: PropTypes.object.isRequired,
  theme: PropTypes.object.isRequired,
};

export default withSnackbar(withRouter(withStyles(styles, { withTheme: true })(SearchCustomers)));
